module.exports = __webpack_public_path__ + "static/media/pattern3.e3af08e2.svg";